module.exports = require('./helpers/bundle-url').getBundleURL('9OGKF') + "logo-dark.eefe0b7f.svg";